import {fetchWithState, getFetchedJSON} from '~/misc/fetch';

const saferwatch = (getState, path) => fetchWithState(getState, {
  url: `/services/saferwatch${path}`,
  method: 'GET',
}, true).then(getFetchedJSON);

export default saferwatch;


// 2084536



// WEBPACK FOOTER //
// ./src/api/saferwatch.js